import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { z } from "zod";
import WorkspaceTeamPage from "@/components/settings/workspace/workspace-team-page";
import { userIdSearchSchema } from "@/lib/search/user-id-search";

const teamSearchSchema = userIdSearchSchema.extend({
	noLicense: z
		.union([z.literal("1"), z.literal(1), z.literal(true), z.literal("true")])
		.optional()
		.catch(undefined),
});

const WorkspaceTeamRoutePage = (): JSX.Element => {
	const { noLicense, userId } = Route.useSearch();
	return <WorkspaceTeamPage focusUserId={userId} reportNoLicense={noLicense != null} />;
};

export const Route = createFileRoute("/_app/settings/workspace/team/")({
	validateSearch: teamSearchSchema,
	component: WorkspaceTeamRoutePage,
});
